import { t } from "@/i18n-js/instance";

export const SOURCE_OPTIONS = [
  {
    value: "upload",
    label: t("builder_ui.prop_type.video_upload.upload_file"),
  },
  {
    value: "url",
    label: t("builder_ui.prop_type.video_upload.url"),
  },
] as const;
